import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { listAlerTypestUrl } from "../../../../config";
import { Status } from "../../../../common/constants";
import api from '../../../../api';
import { RootState } from "../../../../store"; 
import { IListAlertState } from "../../../../common/types/alertsTypes";

const List_AlertTypes: string = "listAlertTypes"

const initialState: IListAlertState = {
  status: null,
  error: null,
  reqId: null,
  msg: null,
  alertTypes:[],
  countyDetails:[], 
};

export const listAlertTypes = createAsyncThunk(List_AlertTypes, async () => {
    try {
      const response = await api.get(listAlerTypestUrl);
      const listAlertPayload ={alertTypes:[],countyDetails:[]};
      const intialValue = { severity: '*', name: 'Select All' };
      listAlertPayload.alertTypes = response?.data?.alertTypes?.reduce((acc,curr)=>{
          const {name,severity} = curr;
          return acc.concat({name,severity:severity[0]})
        },[intialValue])
      listAlertPayload.countyDetails = response?.data?.StateCountyFipsCodeDetails?.reduce((acc, curr) => {
          const { fips, county_name, state_name } = curr;
          return [...acc, { value: fips, name: county_name, state: state_name }];
      }, []);
      return listAlertPayload;
    } catch (error) {
        throw error;
    }
  }
);

const listAlertTypesSlice = createSlice({
  name: List_AlertTypes,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listAlertTypes.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(listAlertTypes.fulfilled, (state, action) => {
        state.msg = 'ALERT LIST FETCHED SUCCESSFULLY';
        state.reqId = Math.random();
        state.status = Status.SUCCESS;
        state.alertTypes = action.payload.alertTypes;
        state.countyDetails = action.payload.countyDetails;
       
      })
      .addCase(listAlertTypes.rejected, (state, action) => {
        state.msg = action.error.message
        state.reqId = Math.random();
        state.status = Status.FAILED;
      });
  },
});

export const selector = (state: RootState) => state.listAlertTypesApi;

export default listAlertTypesSlice.reducer;